import ApplicationSection from './ApplicationSection';

export default ApplicationSection;
